<template>
  <div ref="editor" class="editor"></div>
</template>

<script>
import E from 'wangeditor';
import { uploadFile } from '@/api/httpList';
export default {
  props: {
    value: null,
    showFullScreen: {
      default: true
    },
    toolbar: {
      default() {
        return [
          'head',
          'bold',
          'fontSize',
          'fontName',
          'underline',
          'strikeThrough',
          'indent',
          'lineHeight',
          'foreColor',
          'backColor',
          'link',
          'todo',
          'justify',
          'quote',
          'emoticon',
          'image',
          'video',
          'table',
          'code',
          'splitLine',
          'undo',
          'redo'
        ];
      }
    },
    placeholder: {
      type: String,
      default: '请输入正文'
    }
  },
  data() {
    return {
      change: '',
      isFirstInit: false
    };
  },
  watch: {
    value(newVal) {
      if (!this.change) {
        this.editor && this.editor.txt.html(newVal);
      }
      this.change = true;
    }
  },
  beforeDestroy() {
    // 销毁编辑器
    this.editor.destroy();
    this.editor = null;
  },
  mounted() {
    this.editor = new E(this.$refs.editor);
    this.editor.config.placeholder = this.placeholder;
    this.editor.config.uploadImgServer = '/upload-img';
    // this.editor.config.uploadImgMaxLength = 1;//限制图片选中的个数
    // this.editor.config.uploadImgMaxSize = 3 * 1024 * 1024;//限制上传图片的大小(3M)
    this.editor.config.onchange = newHtml => {
      this.$emit('input', newHtml);
      this.$emit('change', newHtml);
    };
    /**
     * 复制链接文本到剪切板
     * @param {*} resultFiles input 中选中的文件列表
     * @param {*} insertImgFn 获取图片 url 后，插入到编辑器的方法
     */
    this.editor.config.customUploadImg = (resultFiles, insertImgFn) => {
      resultFiles.forEach(item => {
        // 上传图片，返回结果，将图片插入到编辑器中
        let formData = new FormData();
        formData.append('file', item);
        uploadFile(formData).then(res => {
          insertImgFn(res.data[0].path);
        });
      });
    };
    this.editor.config.pasteTextHandle = pasteStr => {
      // 判断是否包含图片
      let isImgTag = pasteStr.includes('img');
      if (isImgTag) {
        // 用于计数图片数量
        let imgNum = 0;
        //匹配图片
        var imgReg = /<img.*?(?:>|\/>)/gi;
        //匹配src属性
        var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
        pasteStr.replace(imgReg, txt => {
          return txt.replace(srcReg, src => {
            var img_src = src.match(srcReg)[1];
            //正则把?x-oss-process后面的都去掉
            img_src = img_src.replace(/\?.*/i, '');

            // 不属于系统域名图片进行转载，已转过不需要直接插入
            if (this.getHost(img_src).indexOf('file.lazhuyun.cn') == -1) {
              // 查找到一个图片地址就讲图片数量加1
              imgNum++;
              this.$http({
                url: '/upload/fileToLocal',
                type: 'POST',
                data: {
                  fileUrl: img_src //decodeURIComponent(img_src)
                }
              }).then(res => {
                // 得到图片地址进行替换并将替换之后的文本返回渲染
                pasteStr = pasteStr.replace(img_src, res.data);
                // 替换之后将图片数量减1
                imgNum--;
                // 只有图片数量变成0的时候才会进行返回
                if (imgNum == 0) {
                  // 给img标签上添加max-widht:100%
                  pasteStr = pasteStr.replace(/\<img (src="((?!\").)+")\/\>/gi, '<img $1 style="max-width:100%;"/>');
                  this.editor && this.editor.txt.append(pasteStr);
                }
              });
            } else {
              // 给img标签上添加max-widht:100%
              pasteStr = pasteStr.replace(/\<img (src="((?!\").)+")\/\>/gi, '<img $1 style="max-width:100%;"/>');
              this.editor && this.editor.txt.append(pasteStr);
            }
          });
        });
      } else {
        return pasteStr;
      }
    };

    this.editor.config.menus = this.toolbar;
    this.editor.config.showFullScreen = this.showFullScreen;
    this.editor.create();
    this.editor.txt.html(this.value);
  },

  methods: {
    initHtml(value) {
      this.editor && this.editor.txt.html(value);
    },
    setDisabled(isDisabled) {
      // 实例不存在延迟500毫秒调用
      if (!this.editor) {
        window.setTimeout(() => {
          this.setDisabled(isDisabled);
        }, 500);
        return;
      }
      if (isDisabled) {
        this.editor.disable();
      } else {
        this.editor.enable();
      }
    },
    // 获取URL中与域名
    getHost(url) {
      var host = '';
      var regex = /^\w+\:\/\/([^\/]*).*/;
      var match = url.match(regex);
      if (match) {
        host = match[1];
      }
      return host;
    }
  }
};
</script>

<style lang="scss" scoped>
.editor /deep/ .w-e-text-container {
  z-index: 1 !important;
}

.editor /deep/ .w-e-toolbar {
  z-index: 1000 !important;
}
</style>
